import { http } from './client'
import type {
  ImpactInputsResponse,
  TrendNarrativeResponse,
  TrendPeriod,
  TrendsResponse,
} from '../types/api'

/**
 * DEC-196: `includeTeamRepos` is the viewer's choice of team repositories. Undefined
 * leaves it to the server, which uses the choice it remembers for this user; an array
 * (empty included) is a new choice, which the server stores. Sent as repeated
 * `include_team_repos`, and as one empty value for "none".
 */
function teamParams(qs: URLSearchParams, includeTeamRepos?: string[]) {
  if (includeTeamRepos === undefined) return
  if (includeTeamRepos.length === 0) qs.append('include_team_repos', '')
  for (const repo of includeTeamRepos) qs.append('include_team_repos', repo)
}

export async function getTrends(
  period: TrendPeriod = 'month',
  repoUrl?: string,
  includeTeamRepos?: string[],
): Promise<TrendsResponse> {
  const qs = new URLSearchParams({ period })
  if (repoUrl) qs.set('repo_url', repoUrl)
  teamParams(qs, includeTeamRepos)
  return http.get(`/api/v1/trends?${qs}`)
}

export async function getTrendNarrative(
  period: TrendPeriod = 'month',
  includeTeamRepos?: string[],
): Promise<TrendNarrativeResponse> {
  const qs = new URLSearchParams({ period })
  teamParams(qs, includeTeamRepos)
  return http.get(`/api/v1/trends/narrative?${qs}`)
}

export async function getImpactInputs(): Promise<ImpactInputsResponse> {
  return http.get('/api/v1/impact-inputs')
}

export async function putImpactInputs(body: {
  values?: Record<string, number>
  /** Distinct intent from omitting a key: clearing re-blocks the metrics that depend on it. */
  clear?: string[]
}): Promise<ImpactInputsResponse> {
  return http.put('/api/v1/impact-inputs', body)
}
